import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { SbDateTime, SbLocalDateTime } from '../../../../services/api/api-date-time';
import { PermissionService } from '../../../../services/permission.service';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { ExportModalOptions } from 'src/app/services/gui/modal/sb-export-modal/sb-export-modal.model';
import { SbExportModalComponent } from 'src/app/services/gui/modal/sb-export-modal/sb-export-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-device-details-playouts',
  templateUrl: './device-details-playouts.component.html',
  styleUrls: ['./device-details-playouts.component.scss'],
  standalone: false,
})
export class DeviceDetailsPlayoutsComponent implements OnInit {
  deviceId: number;
  date: SbDateTime;

  constructor(
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public modal: ModalService,
    public permissionService: PermissionService,
    private translate: TranslateService
  ) {
    this.deviceId = null;
    this.date = null;
  }

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
    });
  }

  handleDateChange(date: SbLocalDateTime) {
    if (date) {
      this.date = new SbDateTime(date.value);
    }
  }

  refresh() {
    this.date = new SbDateTime(DateTime.local());
  }

  export(): void {
    const exportOptions: ExportModalOptions = {
      kind: 'DEVICE_PLAYOUTS',
      id: this.deviceId,
    };
    this.modal
      .showNavigationModal({
        entryComponent: {
          value: SbExportModalComponent,
          data: exportOptions,
        },
        title: this.translate.instant('lang.globals.device') + ' ' + this.deviceId,
        modalOptions: { size: 'lg' },
      })
      .then(() => {})
      .catch(() => {});
  }
}
